import {
  Box,
  VStack,
  Text,
  Center,
  Icon,
  HStack,
  Spinner,
} from '@chakra-ui/react'
import { LuUsers } from 'react-icons/lu'
import PatientListItem from './components/PatientListItem'
import { usePatientsList } from '../../../api/api_hooks/patients'
import Pagination from '../../Pagination'
import { useTranslation } from 'react-i18next'

interface PatientsListProps {
  search?: string
}

export default function PatientsList({ search = '' }: PatientsListProps) {
  const { data, isLoading } = usePatientsList()
  const { t } = useTranslation()

  const allPatients: any[] = data?.data ?? []
  const filtered = search.trim()
    ? allPatients.filter((p) => {
        const full = `${p.firstName ?? ''} ${p.lastName ?? ''}`.toLowerCase()
        return full.includes(search.toLowerCase())
      })
    : allPatients

  if (isLoading) {
    return (
      <Center flex={1} py={16}>
        <Spinner size="lg" color="purple.500" thickness="3px" />
      </Center>
    )
  }

  return (
    <Box display="flex" flexDirection="column" flex={1} overflow="hidden">

      {/* Column headers */}
      <Box
        bg="white"
        borderBottom="1px solid"
        borderColor="gray.100"
        px={6}
        py={3}
      >
        <HStack spacing={0}>
          <Box w="44px" flexShrink={0} />
          <Text flex={2} fontSize="xs" fontWeight="semibold" color="gray.400" textTransform="uppercase" letterSpacing="0.06em">
            Patient
          </Text>
          <Text flex={1} fontSize="xs" fontWeight="semibold" color="gray.400" textTransform="uppercase" letterSpacing="0.06em" display={{ base: 'none', md: 'block' }}>
            {t('shared.common.gender')}
          </Text>
          <Text flex={1} fontSize="xs" fontWeight="semibold" color="gray.400" textTransform="uppercase" letterSpacing="0.06em" display={{ base: 'none', lg: 'block' }}>
            {t('shared.common.dateOfBirthLabel')}
          </Text>
          <Text flex={2} fontSize="xs" fontWeight="semibold" color="gray.400" textTransform="uppercase" letterSpacing="0.06em" display={{ base: 'none', xl: 'block' }}>
            {t('shared.common.fullAddressLabel')}
          </Text>
          <Box w="40px" flexShrink={0} />
        </HStack>
      </Box>

      {/* List */}
      <Box flex={1} overflowY="auto">
        {filtered.length === 0 ? (
          <Center py={16}>
            <VStack spacing={3} color="gray.400">
              <Icon as={LuUsers} boxSize={12} />
              <Text fontSize="md" fontWeight="medium">
                {search ? `${t('patient.noResults')} "${search}"` : t('patient.noPatients')}
              </Text>
              {search && (
                <Text fontSize="sm" color="gray.300">
                  Vérifiez l'orthographe ou créez un nouveau dossier
                </Text>
              )}
            </VStack>
          </Center>
        ) : (
          <VStack spacing={0} align="stretch" divider={<Box h="1px" bg="gray.50" />}>
            {filtered.map((item: any) => (
              <PatientListItem
                key={item.id}
                patientData={{ id: item.id, ...item }}
              />
            ))}
          </VStack>
        )}
      </Box>

      {!search && <Pagination data={data} pageName="patientsPage" />}
    </Box>
  )
}
